import { render, staticRenderFns } from "./BottomBlock.vue?vue&type=template&id=2108a77e&scoped=true"
import script from "./BottomBlock.vue?vue&type=script&lang=js"
export * from "./BottomBlock.vue?vue&type=script&lang=js"
import style0 from "./BottomBlock.vue?vue&type=style&index=0&id=2108a77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108a77e",
  null
  
)

export default component.exports